import { render, staticRenderFns } from "./ScalePointsDatatable.vue?vue&type=template&id=3edea19a&scoped=true"
import script from "./ScalePointsDatatable.vue?vue&type=script&lang=ts"
export * from "./ScalePointsDatatable.vue?vue&type=script&lang=ts"
import style0 from "./ScalePointsDatatable.vue?vue&type=style&index=0&id=3edea19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edea19a",
  null
  
)

export default component.exports